"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const loglevel_1 = __importDefault(require("loglevel"));
const VoxeetRTCShim_1 = require("./adapter/VoxeetRTCShim");
const tough_cookie_1 = require("tough-cookie");
const Exceptions_1 = require("./Exceptions");
/**
 * @ignore
 */
class Endpoints {
    constructor(hashId, getToken, setToken, getUserToken, getRefreshTokenCb, getCurrentConferenceToken, getHost, map, isTokenExpired, getLeavingCallback) {
        this.getHost = getHost;
        this.map = map;
        this.accessToken = null;
        this.conferenceToken = null;
        this.getToken = getToken;
        this.setToken = setToken;
        this.getCurrentConferenceToken = getCurrentConferenceToken;
        this.getUserToken = getUserToken;
        this.getRefreshTokenCb = getRefreshTokenCb;
        this.hashId = hashId;
        this.isTokenExpired = isTokenExpired;
        this.getLeavingCallback = getLeavingCallback;
        if (VoxeetRTCShim_1.isNode) {
            this.cookie = null;
            this.cookiejar = new tough_cookie_1.CookieJar();
            axios_1.default.interceptors.request.use((config) => {
                this.cookiejar.getCookies(config.url, (err, cookies) => {
                    config.headers.cookie = cookies.join('; ');
                });
                return config;
            });
            axios_1.default.interceptors.response.use((response) => {
                if (response.headers['set-cookie'] instanceof Array) {
                    response.headers['set-cookie'].forEach((c) => {
                        const cp = tough_cookie_1.Cookie.parse(c);
                        if (cp.key === 'vxtk') {
                            this.cookiejar.setCookie(cp, response.config.url, function (err, cookie) { });
                            this.cookie = cp.value;
                        }
                    });
                }
                return response;
            });
        }
        axios_1.default.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            const { response: { status }, } = error;
            if (status === 401) {
                this.getLeavingCallback();
                return Promise.reject(error);
            }
            return Promise.reject(error);
        });
        this.inject();
    }
    handleRequest(uri, method, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = params && params.data ? params.data : {};
            const queryParams = params && params.queryParams ? params.queryParams : {};
            let headers = params && params.headers ? params.headers : {};
            let url = this.getHost() + this.templateUri(uri, params) + this.appendQueryParams(queryParams);
            // Check if token has expired to refresh it
            if (this.isTokenExpired()) {
                yield this.getRefreshTokenCb();
            }
            this.accessToken = this.getToken();
            this.jwtUserToken = this.getUserToken ? this.getUserToken() : null;
            this.conferenceToken = this.getCurrentConferenceToken ? this.getCurrentConferenceToken() : null;
            headers = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, headers), { 'Content-Type': 'application/json', 'Voxeet-Id': this.hashId }), (this.accessToken && { Authorization: `Bearer ${this.accessToken}` })), (this.jwtUserToken && { 'X-Token': this.jwtUserToken })), (this.conferenceToken && { 'X-conf-access-token': this.conferenceToken }));
            const config = {
                method: method,
                headers: headers,
                withCredentials: true,
            };
            if (params && params.keepAlive) {
                config.keepalive = true;
                config.body = JSON.stringify(data);
                return fetch(url, config);
            }
            config.data = data;
            config.url = url;
            return axios_1.default(config)
                .then((d) => {
                return d;
            })
                .catch((e) => {
                if (e.response && e.response.data.error_code === 114) {
                    throw Exceptions_1.InsufficientPermissionsError();
                }
                else {
                    throw new Exceptions_1.ServerError(e);
                }
            });
        });
    }
    appendQueryParams(queryParams) {
        let str = [];
        for (let queryParamsKey in queryParams) {
            if (queryParams.hasOwnProperty(queryParamsKey)) {
                str.push(encodeURIComponent(queryParamsKey) + '=' + encodeURIComponent(queryParams[queryParamsKey]));
            }
        }
        if (str.length > 0) {
            return '?' + str.join('&');
        }
        return '';
    }
    templateUri(uri, params) {
        const pattern = /\{([^\{\}]+)\}/g;
        return uri.replace(pattern, (match, key) => {
            if (!params[key]) {
                loglevel_1.default.debug('Failed to find parameter :', key, 'for uri: ', uri);
            }
            return params[key];
        });
    }
    inject() {
        this['getCookie'] = function () {
            return this.cookie;
        };
        for (let key in this.map) {
            this[key] = function (params) {
                return this.handleRequest(this.map[key].uri, this.map[key].method, params);
            };
        }
    }
}
/**
 * @ignore
 */
class ApiInjector {
    static inject(object, getToken, setToken, getUserToken, getTokenCb, getCurrentConferenceToken, getHost, map, isStatic = false, isTokenExpired, getLeavingCallback) {
        const hashId = ApiInjector.generateId(40);
        for (let key in map) {
            if (isStatic) {
                object[key] = new Endpoints(hashId, getToken, setToken, getUserToken, getTokenCb, getCurrentConferenceToken, getHost, map[key], isTokenExpired, getLeavingCallback);
                object['getHashId'] = function () {
                    return hashId;
                };
            }
            else {
                object.prototype[key] = new Endpoints(hashId, getToken, setToken, getUserToken, getTokenCb, getCurrentConferenceToken, getHost, map[key], isTokenExpired, getLeavingCallback);
                object.prototype['getHashId'] = function () {
                    return hashId;
                };
            }
        }
        object.prototype['getHashId'] = function () {
            return hashId;
        };
        return object;
    }
    static byteToHex(byte) {
        return ('0' + byte.toString(16)).slice(-2);
    }
    static generateId(N) {
        return Array(N + 1)
            .join((Math.random().toString(36) + '00000000000000000').slice(2, 18))
            .slice(0, N);
    }
}
exports.default = ApiInjector;
